/**
 * @format
 */

import React from 'react';
import { isArray } from 'lodash';

import { BusinessHour } from '../../api/adserver';

import HourListItem from './HourListItem';

export interface Props {
  list?: BusinessHour[] | null;
  onPress?: (item: any) => void;
}

const HourListItemRender: React.FC<Props> = (props) => {
  const { list } = props;
  if (!list || !isArray(list) || list.length === 0) {
    return null;
  }
  return (
    <>
      {Object.values(list).map((hour) => {
        return <HourListItem item={hour} key={hour.id} />;
      })}
    </>
  );
};

export default HourListItemRender;
